/*eslint-disable no-undef,no-redeclare,no-empty,no-unused-vars */
import April from '../../ALizard/April'

export default ()=>{
    April.define("log.heal", function(args){
        if(args.opr == 'split'){
            return false;
        }else if(args.opr == 'next'){
            args.scene.member[args.player].HP+=args.fact;
        }else if(args.opr == 'back'){
            args.scene.member[args.player].HP-=args.fact;
        }else if(args.opr == 'play'){
            var scene=args.scene;
            var ch = args.scene.member[args.player];
            scene.flare("act_console", {value: "call heal", args: args});
            args.tweener
                .call(function(_args){
                    ch.HP += _args.fact;
                }, null, [args])
                .call(function(_args){
                    DebugCounter({
                        value: _args.heal,
                        digitFont: "img/ui/font13.png",
                        digitWidth: 30,
                        digitHeight: 45,
                        digitStyle: _args.color||'h',
                    }).addChildTo(ch).setPosition(0,0);
                }, null, [args]);
        }
    });
    
    April.define("DisplayComponent/heal.debug-charge", function(args){
        if(args.opr == 'split'){
            return false;
        }else if(args.opr == 'next'){
            args.scene.member[args.player].GP+=args.fact;
        }else if(args.opr == 'back'){
            args.scene.member[args.player].GP-=args.fact;
        }else if(args.opr == 'play'){
            var scene=args.scene;
            var ch = args.scene.member[args.player];
            scene.flare("act_console", {value: "call DisplayComponent/heal.debug-charge", args: args});
            args.tweener
                .call(function(_args){
                    ch.GP += _args.fact;
                }, null, [args]);
        }
    });    
}
